import globalAxios from 'axios';
import { B as BaseAPI, D as DUMMY_BASE_URL, s as setBearerAuthToObject, b as setSearchParams, c as serializeDataIfNeeded, t as toPathString, a as assertParamExists, o as operationServerMap, d as createRequestFunction, e as BASE_PATH } from '../common-BuhUSHAi.js';

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * CustomersApi - axios parameter creator
 * @export
 */
const CustomersApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {CustomerEmployeeToken} [CustomerEmployeeToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addEmployee: async (CustomerEmployeeToken, options = {}) => {
            const localVarPath = `/v1/Customers/AddEmployee`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(CustomerEmployeeToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {CustomerAppleToken} [CustomerAppleToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appleLogin: async (CustomerAppleToken, options = {}) => {
            const localVarPath = `/v1/Customers/AppleLogin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(CustomerAppleToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Issues a one-time nonce challenge for the Sign in with Apple flow. The storefront requests this before initialising the Apple JS SDK, feeds `nonce` to Apple, and posts `nonceToken` back on M:BizWeb.NC.API.Controllers.CustomersController.AppleLogin(BizWeb.NC.Models.Customers.CustomerAppleToken) so the server can bind the identity token to this attempt without server state.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appleNonce: async (options = {}) => {
            const localVarPath = `/v1/Customers/AppleNonce`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Confirms and executes account deletion using token from email
         * @param {string} [token] The unique deletion confirmation token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmAccountDeletion: async (token, options = {}) => {
            const localVarPath = `/v1/Customers/ConfirmAccountDeletion`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Customers,OrderApproval)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countAll: async (options = {}) => {
            const localVarPath = `/v1/Customers/countAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Customers,FrontEndUsers)
         * @param {number} [customerId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomerImpersonation: async (customerId, options = {}) => {
            const localVarPath = `/v1/Customers/CreateCustomerImpersonation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccount: async (options = {}) => {
            const localVarPath = `/v1/Customers/DeleteAccount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEmployee: async (id, options = {}) => {
            const localVarPath = `/v1/Customers/DeleteEmployee`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {CustomerFacebookToken} [CustomerFacebookToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facebookLogin: async (CustomerFacebookToken, options = {}) => {
            const localVarPath = `/v1/Customers/FacebookLogin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(CustomerFacebookToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {GeneratePasswordRequestToken} [GeneratePasswordRequestToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generatePasswordRequest: async (GeneratePasswordRequestToken, options = {}) => {
            const localVarPath = `/v1/Customers/GeneratePasswordRequest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(GeneratePasswordRequestToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Customers, Erp)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll: async (options = {}) => {
            const localVarPath = `/v1/Customers/GetAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllByCustomerCategory: async (id, options = {}) => {
            const localVarPath = `/v1/Customers/GetAllByCustomerCategory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCustomerDimensionValues: async (options = {}) => {
            const localVarPath = `/v1/Customers/GetAllCustomerDimensionValues`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: System, Customers, Erp)
         * @param {CustomerGetAllRequest} [CustomerGetAllRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPost: async (CustomerGetAllRequest, options = {}) => {
            const localVarPath = `/v1/Customers/GetAllPost`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(CustomerGetAllRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [page]
         * @param {number} [psize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllReaders: async (page, psize, options = {}) => {
            const localVarPath = `/v1/Customers/GetAllReaders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (psize !== undefined) {
                localVarQueryParameter['psize'] = psize;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBranches: async (options = {}) => {
            const localVarPath = `/v1/Customers/GetBranches`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBusinessCode: async (options = {}) => {
            const localVarPath = `/v1/Customers/GetBusinessCode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Orders, Customers, Erp)
         * @param {string} [erpSyncCode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByErpCode: async (erpSyncCode, options = {}) => {
            const localVarPath = `/v1/Customers/GetByErpCode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (erpSyncCode !== undefined) {
                localVarQueryParameter['erpSyncCode'] = erpSyncCode;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Customers, Erp)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById: async (id, options = {}) => {
            const localVarPath = `/v1/Customers/GetById`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {Array<number>} [request_body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByIds: async (request_body, options = {}) => {
            const localVarPath = `/v1/Customers/GetByIds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(request_body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [userAlias]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByUserAlias: async (userAlias, options = {}) => {
            const localVarPath = `/v1/Customers/GetByUserAlias`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (userAlias !== undefined) {
                localVarQueryParameter['userAlias'] = userAlias;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCouponOrderLines: async (options = {}) => {
            const localVarPath = `/v1/Customers/GetCouponOrderLines`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {string} key
         * @param {string} [group]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentCustomerMeta: async (key, group, options = {}) => {
            // verify required parameter 'key' is not null or undefined
            assertParamExists('getCurrentCustomerMeta', 'key', key);
            const localVarPath = `/v1/Customers/GetCurrentCustomerMeta/{key}`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (group !== undefined) {
                localVarQueryParameter['group'] = group;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerAvailableLoyaltyPoints: async (options = {}) => {
            const localVarPath = `/v1/Customers/GetCustomerAvailableLoyaltyPoints`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerDimensionValues: async (options = {}) => {
            const localVarPath = `/v1/Customers/GetCustomerDimensionValues`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [guid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerOfPasswordResetRequest: async (guid, options = {}) => {
            const localVarPath = `/v1/Customers/GetCustomerOfPasswordResetRequest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (guid !== undefined) {
                localVarQueryParameter['guid'] = guid;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployees: async (options = {}) => {
            const localVarPath = `/v1/Customers/GetEmployees`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary The product feeds published for the signed-in customer (an employee gets their company\'s), as absolute URLs. Empty when feeds are not published per customer or the customer has no GUID. (Auth roles: FrontEndUsers)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeeds: async (options = {}) => {
            const localVarPath = `/v1/Customers/GetFeeds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGenders: async (options = {}) => {
            const localVarPath = `/v1/Customers/GetGenders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Groups the customer currently belongs to (read-only, for the admin customer form). (Auth roles: Customers)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroups: async (id, options = {}) => {
            const localVarPath = `/v1/Customers/GetGroups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoyaltyEventInfo: async (options = {}) => {
            const localVarPath = `/v1/Customers/GetLoyaltyEventInfo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoyaltyPointsBalance: async (options = {}) => {
            const localVarPath = `/v1/Customers/GetLoyaltyPointsBalance`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers,Customers)
         * @param {number} customerId
         * @param {string} key
         * @param {string} [group]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeta: async (customerId, key, group, options = {}) => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getMeta', 'customerId', customerId);
            // verify required parameter 'key' is not null or undefined
            assertParamExists('getMeta', 'key', key);
            const localVarPath = `/v1/Customers/GetMeta/{customerId}/{key}`
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (group !== undefined) {
                localVarQueryParameter['group'] = group;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {number} [winPoints]
         * @param {number} [redeemPoints]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNextMilestone: async (winPoints, redeemPoints, options = {}) => {
            const localVarPath = `/v1/Customers/GetNextMilestone`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (winPoints !== undefined) {
                localVarQueryParameter['winPoints'] = winPoints;
            }
            if (redeemPoints !== undefined) {
                localVarQueryParameter['redeemPoints'] = redeemPoints;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfile: async (options = {}) => {
            const localVarPath = `/v1/Customers/GetProfile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReaderInfo: async (id, options = {}) => {
            const localVarPath = `/v1/Customers/GetReaderInfo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {CustomerGoogleToken} [CustomerGoogleToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        googleLogin: async (CustomerGoogleToken, options = {}) => {
            const localVarPath = `/v1/Customers/GoogleLogin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(CustomerGoogleToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [guid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        impersonateCustomer: async (guid, options = {}) => {
            const localVarPath = `/v1/Customers/ImpersonateCustomer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (guid !== undefined) {
                localVarQueryParameter['guid'] = guid;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Customers, Erp)
         * @param {CustomerToken} [CustomerToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insert: async (CustomerToken, options = {}) => {
            const localVarPath = `/v1/Customers/Insert`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(CustomerToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sample request:   POST /api/v1/Customers/IssueSlt  {   \"username\": \"user@my.org\",   \"password\": \"1234567890\"  }   Sample response:   {   \"token\": \"dsjhfcasod8n7fyoacw87y023874nyc023n8974ty02mcc347cn023470734yc208734ynt28\"  }
         * @summary Issue an slt token to be used for authentication in a second step
         * @param {BaseLoginArgs} BaseLoginArgs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        issueSlt: async (BaseLoginArgs, options = {}) => {
            // verify required parameter 'BaseLoginArgs' is not null or undefined
            assertParamExists('issueSlt', 'BaseLoginArgs', BaseLoginArgs);
            const localVarPath = `/v1/Customers/IssueSlt/IssueSlt`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(BaseLoginArgs, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {LoginArgs} [LoginArgs]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login: async (LoginArgs, options = {}) => {
            const localVarPath = `/v1/Customers/Login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(LoginArgs, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {LoginSltArgs} [LoginSltArgs]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginSlt: async (LoginSltArgs, options = {}) => {
            const localVarPath = `/v1/Customers/LoginSlt`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(LoginSltArgs, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {RefreshTokenArgs} [RefreshTokenArgs]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout: async (RefreshTokenArgs, options = {}) => {
            const localVarPath = `/v1/Customers/Logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(RefreshTokenArgs, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {string} [term]
         * @param {number} [top]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookup: async (term, top, options = {}) => {
            const localVarPath = `/v1/Customers/Lookup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (top !== undefined) {
                localVarQueryParameter['top'] = top;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {GenericToken} [GenericToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readBlog: async (GenericToken, options = {}) => {
            const localVarPath = `/v1/Customers/ReadBlog`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(GenericToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Invites a friend by e-mail (BW-8460). The answer is the same whether or not the address is already a customer; the mail goes out only when it isn\'t (and wasn\'t invited by this customer in the last 30 days). At most 3 an hour. (Auth roles: FrontEndUsers)
         * @param {ReferAFriendRequest} [ReferAFriendRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        referAFriend: async (ReferAFriendRequest, options = {}) => {
            const localVarPath = `/v1/Customers/ReferAFriend`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(ReferAFriendRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {RefreshTokenArgs} [RefreshTokenArgs]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshToken: async (RefreshTokenArgs, options = {}) => {
            const localVarPath = `/v1/Customers/RefreshToken`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(RefreshTokenArgs, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {CustomerToken} [CustomerToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        register: async (CustomerToken, options = {}) => {
            const localVarPath = `/v1/Customers/Register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(CustomerToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Customers, Erp)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id, options = {}) => {
            const localVarPath = `/v1/Customers/Delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Initiates account deletion request. Sends confirmation email with token. (Auth roles: FrontEndUsers)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestAccountDeletion: async (options = {}) => {
            const localVarPath = `/v1/Customers/RequestAccountDeletion`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ChangePasswordToken} [ChangePasswordToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword: async (ChangePasswordToken, options = {}) => {
            const localVarPath = `/v1/Customers/ResetPassword`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(ChangePasswordToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [email]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPasswordRequest: async (email, options = {}) => {
            const localVarPath = `/v1/Customers/ResetPasswordRequest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ChangePasswordTokenV2} [ChangePasswordTokenV2]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPasswordV2: async (ChangePasswordTokenV2, options = {}) => {
            const localVarPath = `/v1/Customers/ResetPasswordV2`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(ChangePasswordTokenV2, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {string} [businessCode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveBusinessCode: async (businessCode, options = {}) => {
            const localVarPath = `/v1/Customers/SaveBusinessCode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (businessCode !== undefined) {
                localVarQueryParameter['businessCode'] = businessCode;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [pageIndex]
         * @param {number} [pageSize]
         * @param {string} [searchText]
         * @param {string} [startsWith]
         * @param {string} [sort]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUserAlias: async (pageIndex, pageSize, searchText, startsWith, sort, options = {}) => {
            const localVarPath = `/v1/Customers/SearchUserAlias`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (pageIndex !== undefined) {
                localVarQueryParameter['pageIndex'] = pageIndex;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            if (searchText !== undefined) {
                localVarQueryParameter['searchText'] = searchText;
            }
            if (startsWith !== undefined) {
                localVarQueryParameter['startsWith'] = startsWith;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {SettingValue} SettingValue
         * @param {string} key
         * @param {string} [group]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setCurrentCustomerMeta: async (SettingValue, key, group, options = {}) => {
            // verify required parameter 'SettingValue' is not null or undefined
            assertParamExists('setCurrentCustomerMeta', 'SettingValue', SettingValue);
            // verify required parameter 'key' is not null or undefined
            assertParamExists('setCurrentCustomerMeta', 'key', key);
            const localVarPath = `/v1/Customers/SetCurrentCustomerMeta/{key}`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (group !== undefined) {
                localVarQueryParameter['group'] = group;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(SettingValue, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers,Customers)
         * @param {SettingValue} SettingValue
         * @param {number} customerId
         * @param {string} key
         * @param {string} [group]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setMeta: async (SettingValue, customerId, key, group, options = {}) => {
            // verify required parameter 'SettingValue' is not null or undefined
            assertParamExists('setMeta', 'SettingValue', SettingValue);
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('setMeta', 'customerId', customerId);
            // verify required parameter 'key' is not null or undefined
            assertParamExists('setMeta', 'key', key);
            const localVarPath = `/v1/Customers/SetMeta/{customerId}/{key}`
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (group !== undefined) {
                localVarQueryParameter['group'] = group;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(SettingValue, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Customers, Erp)
         * @param {CustomerToken} [CustomerToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (CustomerToken, options = {}) => {
            const localVarPath = `/v1/Customers/Update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(CustomerToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {UpdateCustomerDimensionReq} [UpdateCustomerDimensionReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomerDimensionValues: async (UpdateCustomerDimensionReq, options = {}) => {
            const localVarPath = `/v1/Customers/UpdateCustomerDimensionValues`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(UpdateCustomerDimensionReq, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {CustomerEmployeeToken} [CustomerEmployeeToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmployee: async (CustomerEmployeeToken, options = {}) => {
            const localVarPath = `/v1/Customers/UpdateEmployee`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(CustomerEmployeeToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {ChangePasswordToken} [ChangePasswordToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePassword: async (ChangePasswordToken, options = {}) => {
            const localVarPath = `/v1/Customers/UpdatePassword`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(ChangePasswordToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary The customer\'s own answer to the personalized-messages consent, from the storefront profile. A dedicated action rather than M:BizWeb.NC.API.Controllers.CustomersController.UpdateProfile(BizWeb.NC.API.Models.Customers.CustomerToken), so a consent toggle neither needs the personal details to validate nor re-runs the profile\'s loyalty events and customer-plugin update. (Auth roles: FrontEndUsers)
         * @param {PersonalizedMessagesConsentToken} [PersonalizedMessagesConsentToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePersonalizedMessagesConsent: async (PersonalizedMessagesConsentToken, options = {}) => {
            const localVarPath = `/v1/Customers/UpdatePersonalizedMessagesConsent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(PersonalizedMessagesConsentToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {CustomerToken} [CustomerToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProfile: async (CustomerToken, options = {}) => {
            const localVarPath = `/v1/Customers/UpdateProfile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(CustomerToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [guid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validatePasswordResetRequest: async (guid, options = {}) => {
            const localVarPath = `/v1/Customers/ValidatePasswordResetRequest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (guid !== undefined) {
                localVarQueryParameter['guid'] = guid;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ChangePasswordTokenV2} [ChangePasswordTokenV2]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateResetPassPin: async (ChangePasswordTokenV2, options = {}) => {
            const localVarPath = `/v1/Customers/ValidateResetPassPin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(ChangePasswordTokenV2, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [guid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyRegistration: async (guid, options = {}) => {
            const localVarPath = `/v1/Customers/VerifyRegistration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (guid !== undefined) {
                localVarQueryParameter['guid'] = guid;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {GenericToken} [GenericToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewVideo: async (GenericToken, options = {}) => {
            const localVarPath = `/v1/Customers/ViewVideo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(GenericToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * CustomersApi - functional programming interface
 * @export
 */
const CustomersApiFp = function (configuration) {
    const localVarAxiosParamCreator = CustomersApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {CustomerEmployeeToken} [CustomerEmployeeToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addEmployee(CustomerEmployeeToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addEmployee(CustomerEmployeeToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.addEmployee']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {CustomerAppleToken} [CustomerAppleToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appleLogin(CustomerAppleToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appleLogin(CustomerAppleToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.appleLogin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Issues a one-time nonce challenge for the Sign in with Apple flow. The storefront requests this before initialising the Apple JS SDK, feeds `nonce` to Apple, and posts `nonceToken` back on M:BizWeb.NC.API.Controllers.CustomersController.AppleLogin(BizWeb.NC.Models.Customers.CustomerAppleToken) so the server can bind the identity token to this attempt without server state.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appleNonce(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appleNonce(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.appleNonce']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Confirms and executes account deletion using token from email
         * @param {string} [token] The unique deletion confirmation token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async confirmAccountDeletion(token, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.confirmAccountDeletion(token, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.confirmAccountDeletion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Customers,OrderApproval)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countAll(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countAll(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.countAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Customers,FrontEndUsers)
         * @param {number} [customerId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCustomerImpersonation(customerId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCustomerImpersonation(customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.createCustomerImpersonation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAccount(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAccount(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.deleteAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEmployee(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEmployee(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.deleteEmployee']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {CustomerFacebookToken} [CustomerFacebookToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facebookLogin(CustomerFacebookToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facebookLogin(CustomerFacebookToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.facebookLogin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {GeneratePasswordRequestToken} [GeneratePasswordRequestToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generatePasswordRequest(GeneratePasswordRequestToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generatePasswordRequest(GeneratePasswordRequestToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.generatePasswordRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Customers, Erp)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAll(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAll(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.getAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllByCustomerCategory(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllByCustomerCategory(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.getAllByCustomerCategory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllCustomerDimensionValues(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllCustomerDimensionValues(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.getAllCustomerDimensionValues']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: System, Customers, Erp)
         * @param {CustomerGetAllRequest} [CustomerGetAllRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllPost(CustomerGetAllRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllPost(CustomerGetAllRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.getAllPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [page]
         * @param {number} [psize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllReaders(page, psize, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllReaders(page, psize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.getAllReaders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBranches(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBranches(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.getBranches']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBusinessCode(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBusinessCode(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.getBusinessCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Orders, Customers, Erp)
         * @param {string} [erpSyncCode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByErpCode(erpSyncCode, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByErpCode(erpSyncCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.getByErpCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Customers, Erp)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getById(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.getById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {Array<number>} [request_body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByIds(request_body, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByIds(request_body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.getByIds']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [userAlias]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByUserAlias(userAlias, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByUserAlias(userAlias, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.getByUserAlias']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCouponOrderLines(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCouponOrderLines(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.getCouponOrderLines']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {string} key
         * @param {string} [group]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrentCustomerMeta(key, group, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrentCustomerMeta(key, group, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.getCurrentCustomerMeta']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomerAvailableLoyaltyPoints(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomerAvailableLoyaltyPoints(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.getCustomerAvailableLoyaltyPoints']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomerDimensionValues(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomerDimensionValues(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.getCustomerDimensionValues']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [guid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomerOfPasswordResetRequest(guid, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomerOfPasswordResetRequest(guid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.getCustomerOfPasswordResetRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmployees(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmployees(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.getEmployees']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary The product feeds published for the signed-in customer (an employee gets their company\'s), as absolute URLs. Empty when feeds are not published per customer or the customer has no GUID. (Auth roles: FrontEndUsers)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFeeds(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFeeds(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.getFeeds']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGenders(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGenders(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.getGenders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Groups the customer currently belongs to (read-only, for the admin customer form). (Auth roles: Customers)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGroups(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGroups(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.getGroups']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLoyaltyEventInfo(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLoyaltyEventInfo(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.getLoyaltyEventInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLoyaltyPointsBalance(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLoyaltyPointsBalance(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.getLoyaltyPointsBalance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers,Customers)
         * @param {number} customerId
         * @param {string} key
         * @param {string} [group]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeta(customerId, key, group, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMeta(customerId, key, group, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.getMeta']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {number} [winPoints]
         * @param {number} [redeemPoints]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNextMilestone(winPoints, redeemPoints, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNextMilestone(winPoints, redeemPoints, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.getNextMilestone']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProfile(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProfile(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.getProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReaderInfo(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReaderInfo(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.getReaderInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {CustomerGoogleToken} [CustomerGoogleToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async googleLogin(CustomerGoogleToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.googleLogin(CustomerGoogleToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.googleLogin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [guid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async impersonateCustomer(guid, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.impersonateCustomer(guid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.impersonateCustomer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Customers, Erp)
         * @param {CustomerToken} [CustomerToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async insert(CustomerToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.insert(CustomerToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.insert']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sample request:   POST /api/v1/Customers/IssueSlt  {   \"username\": \"user@my.org\",   \"password\": \"1234567890\"  }   Sample response:   {   \"token\": \"dsjhfcasod8n7fyoacw87y023874nyc023n8974ty02mcc347cn023470734yc208734ynt28\"  }
         * @summary Issue an slt token to be used for authentication in a second step
         * @param {BaseLoginArgs} BaseLoginArgs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async issueSlt(BaseLoginArgs, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.issueSlt(BaseLoginArgs, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.issueSlt']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {LoginArgs} [LoginArgs]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async login(LoginArgs, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.login(LoginArgs, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.login']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {LoginSltArgs} [LoginSltArgs]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginSlt(LoginSltArgs, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginSlt(LoginSltArgs, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.loginSlt']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {RefreshTokenArgs} [RefreshTokenArgs]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async logout(RefreshTokenArgs, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.logout(RefreshTokenArgs, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.logout']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {string} [term]
         * @param {number} [top]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async lookup(term, top, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.lookup(term, top, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.lookup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {GenericToken} [GenericToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async readBlog(GenericToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.readBlog(GenericToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.readBlog']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Invites a friend by e-mail (BW-8460). The answer is the same whether or not the address is already a customer; the mail goes out only when it isn\'t (and wasn\'t invited by this customer in the last 30 days). At most 3 an hour. (Auth roles: FrontEndUsers)
         * @param {ReferAFriendRequest} [ReferAFriendRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async referAFriend(ReferAFriendRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.referAFriend(ReferAFriendRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.referAFriend']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {RefreshTokenArgs} [RefreshTokenArgs]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refreshToken(RefreshTokenArgs, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refreshToken(RefreshTokenArgs, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.refreshToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {CustomerToken} [CustomerToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async register(CustomerToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.register(CustomerToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.register']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Customers, Erp)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.remove']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Initiates account deletion request. Sends confirmation email with token. (Auth roles: FrontEndUsers)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestAccountDeletion(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestAccountDeletion(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.requestAccountDeletion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {ChangePasswordToken} [ChangePasswordToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetPassword(ChangePasswordToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetPassword(ChangePasswordToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.resetPassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [email]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetPasswordRequest(email, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetPasswordRequest(email, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.resetPasswordRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {ChangePasswordTokenV2} [ChangePasswordTokenV2]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetPasswordV2(ChangePasswordTokenV2, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetPasswordV2(ChangePasswordTokenV2, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.resetPasswordV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {string} [businessCode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveBusinessCode(businessCode, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveBusinessCode(businessCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.saveBusinessCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [pageIndex]
         * @param {number} [pageSize]
         * @param {string} [searchText]
         * @param {string} [startsWith]
         * @param {string} [sort]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchUserAlias(pageIndex, pageSize, searchText, startsWith, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchUserAlias(pageIndex, pageSize, searchText, startsWith, sort, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.searchUserAlias']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {SettingValue} SettingValue
         * @param {string} key
         * @param {string} [group]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setCurrentCustomerMeta(SettingValue, key, group, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setCurrentCustomerMeta(SettingValue, key, group, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.setCurrentCustomerMeta']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers,Customers)
         * @param {SettingValue} SettingValue
         * @param {number} customerId
         * @param {string} key
         * @param {string} [group]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setMeta(SettingValue, customerId, key, group, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setMeta(SettingValue, customerId, key, group, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.setMeta']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Customers, Erp)
         * @param {CustomerToken} [CustomerToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(CustomerToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(CustomerToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.update']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {UpdateCustomerDimensionReq} [UpdateCustomerDimensionReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCustomerDimensionValues(UpdateCustomerDimensionReq, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCustomerDimensionValues(UpdateCustomerDimensionReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.updateCustomerDimensionValues']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {CustomerEmployeeToken} [CustomerEmployeeToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEmployee(CustomerEmployeeToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEmployee(CustomerEmployeeToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.updateEmployee']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {ChangePasswordToken} [ChangePasswordToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePassword(ChangePasswordToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePassword(ChangePasswordToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.updatePassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary The customer\'s own answer to the personalized-messages consent, from the storefront profile. A dedicated action rather than M:BizWeb.NC.API.Controllers.CustomersController.UpdateProfile(BizWeb.NC.API.Models.Customers.CustomerToken), so a consent toggle neither needs the personal details to validate nor re-runs the profile\'s loyalty events and customer-plugin update. (Auth roles: FrontEndUsers)
         * @param {PersonalizedMessagesConsentToken} [PersonalizedMessagesConsentToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePersonalizedMessagesConsent(PersonalizedMessagesConsentToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePersonalizedMessagesConsent(PersonalizedMessagesConsentToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.updatePersonalizedMessagesConsent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {CustomerToken} [CustomerToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProfile(CustomerToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProfile(CustomerToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.updateProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [guid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validatePasswordResetRequest(guid, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validatePasswordResetRequest(guid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.validatePasswordResetRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {ChangePasswordTokenV2} [ChangePasswordTokenV2]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateResetPassPin(ChangePasswordTokenV2, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateResetPassPin(ChangePasswordTokenV2, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.validateResetPassPin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [guid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyRegistration(guid, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyRegistration(guid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.verifyRegistration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {GenericToken} [GenericToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async viewVideo(GenericToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.viewVideo(GenericToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.viewVideo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * CustomersApi - factory interface
 * @export
 */
const CustomersApiFactory = function (configuration, basePath, axios) {
    const localVarFp = CustomersApiFp(configuration);
    return {
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {CustomerEmployeeToken} [CustomerEmployeeToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addEmployee(CustomerEmployeeToken, options) {
            return localVarFp.addEmployee(CustomerEmployeeToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CustomerAppleToken} [CustomerAppleToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appleLogin(CustomerAppleToken, options) {
            return localVarFp.appleLogin(CustomerAppleToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Issues a one-time nonce challenge for the Sign in with Apple flow. The storefront requests this before initialising the Apple JS SDK, feeds `nonce` to Apple, and posts `nonceToken` back on M:BizWeb.NC.API.Controllers.CustomersController.AppleLogin(BizWeb.NC.Models.Customers.CustomerAppleToken) so the server can bind the identity token to this attempt without server state.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appleNonce(options) {
            return localVarFp.appleNonce(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Confirms and executes account deletion using token from email
         * @param {string} [token] The unique deletion confirmation token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmAccountDeletion(token, options) {
            return localVarFp.confirmAccountDeletion(token, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Customers,OrderApproval)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countAll(options) {
            return localVarFp.countAll(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Customers,FrontEndUsers)
         * @param {number} [customerId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomerImpersonation(customerId, options) {
            return localVarFp.createCustomerImpersonation(customerId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccount(options) {
            return localVarFp.deleteAccount(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEmployee(id, options) {
            return localVarFp.deleteEmployee(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CustomerFacebookToken} [CustomerFacebookToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facebookLogin(CustomerFacebookToken, options) {
            return localVarFp.facebookLogin(CustomerFacebookToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {GeneratePasswordRequestToken} [GeneratePasswordRequestToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generatePasswordRequest(GeneratePasswordRequestToken, options) {
            return localVarFp.generatePasswordRequest(GeneratePasswordRequestToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Customers, Erp)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll(options) {
            return localVarFp.getAll(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllByCustomerCategory(id, options) {
            return localVarFp.getAllByCustomerCategory(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCustomerDimensionValues(options) {
            return localVarFp.getAllCustomerDimensionValues(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: System, Customers, Erp)
         * @param {CustomerGetAllRequest} [CustomerGetAllRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPost(CustomerGetAllRequest, options) {
            return localVarFp.getAllPost(CustomerGetAllRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page]
         * @param {number} [psize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllReaders(page, psize, options) {
            return localVarFp.getAllReaders(page, psize, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBranches(options) {
            return localVarFp.getBranches(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBusinessCode(options) {
            return localVarFp.getBusinessCode(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Orders, Customers, Erp)
         * @param {string} [erpSyncCode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByErpCode(erpSyncCode, options) {
            return localVarFp.getByErpCode(erpSyncCode, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Customers, Erp)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById(id, options) {
            return localVarFp.getById(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {Array<number>} [request_body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByIds(request_body, options) {
            return localVarFp.getByIds(request_body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [userAlias]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByUserAlias(userAlias, options) {
            return localVarFp.getByUserAlias(userAlias, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCouponOrderLines(options) {
            return localVarFp.getCouponOrderLines(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {string} key
         * @param {string} [group]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentCustomerMeta(key, group, options) {
            return localVarFp.getCurrentCustomerMeta(key, group, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerAvailableLoyaltyPoints(options) {
            return localVarFp.getCustomerAvailableLoyaltyPoints(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerDimensionValues(options) {
            return localVarFp.getCustomerDimensionValues(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [guid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerOfPasswordResetRequest(guid, options) {
            return localVarFp.getCustomerOfPasswordResetRequest(guid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployees(options) {
            return localVarFp.getEmployees(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary The product feeds published for the signed-in customer (an employee gets their company\'s), as absolute URLs. Empty when feeds are not published per customer or the customer has no GUID. (Auth roles: FrontEndUsers)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeeds(options) {
            return localVarFp.getFeeds(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGenders(options) {
            return localVarFp.getGenders(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Groups the customer currently belongs to (read-only, for the admin customer form). (Auth roles: Customers)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroups(id, options) {
            return localVarFp.getGroups(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoyaltyEventInfo(options) {
            return localVarFp.getLoyaltyEventInfo(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoyaltyPointsBalance(options) {
            return localVarFp.getLoyaltyPointsBalance(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers,Customers)
         * @param {number} customerId
         * @param {string} key
         * @param {string} [group]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeta(customerId, key, group, options) {
            return localVarFp.getMeta(customerId, key, group, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {number} [winPoints]
         * @param {number} [redeemPoints]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNextMilestone(winPoints, redeemPoints, options) {
            return localVarFp.getNextMilestone(winPoints, redeemPoints, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfile(options) {
            return localVarFp.getProfile(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReaderInfo(id, options) {
            return localVarFp.getReaderInfo(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CustomerGoogleToken} [CustomerGoogleToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        googleLogin(CustomerGoogleToken, options) {
            return localVarFp.googleLogin(CustomerGoogleToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [guid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        impersonateCustomer(guid, options) {
            return localVarFp.impersonateCustomer(guid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Customers, Erp)
         * @param {CustomerToken} [CustomerToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insert(CustomerToken, options) {
            return localVarFp.insert(CustomerToken, options).then((request) => request(axios, basePath));
        },
        /**
         * Sample request:   POST /api/v1/Customers/IssueSlt  {   \"username\": \"user@my.org\",   \"password\": \"1234567890\"  }   Sample response:   {   \"token\": \"dsjhfcasod8n7fyoacw87y023874nyc023n8974ty02mcc347cn023470734yc208734ynt28\"  }
         * @summary Issue an slt token to be used for authentication in a second step
         * @param {BaseLoginArgs} BaseLoginArgs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        issueSlt(BaseLoginArgs, options) {
            return localVarFp.issueSlt(BaseLoginArgs, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {LoginArgs} [LoginArgs]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login(LoginArgs, options) {
            return localVarFp.login(LoginArgs, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {LoginSltArgs} [LoginSltArgs]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginSlt(LoginSltArgs, options) {
            return localVarFp.loginSlt(LoginSltArgs, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {RefreshTokenArgs} [RefreshTokenArgs]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout(RefreshTokenArgs, options) {
            return localVarFp.logout(RefreshTokenArgs, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Customers)
         * @param {string} [term]
         * @param {number} [top]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookup(term, top, options) {
            return localVarFp.lookup(term, top, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {GenericToken} [GenericToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readBlog(GenericToken, options) {
            return localVarFp.readBlog(GenericToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Invites a friend by e-mail (BW-8460). The answer is the same whether or not the address is already a customer; the mail goes out only when it isn\'t (and wasn\'t invited by this customer in the last 30 days). At most 3 an hour. (Auth roles: FrontEndUsers)
         * @param {ReferAFriendRequest} [ReferAFriendRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        referAFriend(ReferAFriendRequest, options) {
            return localVarFp.referAFriend(ReferAFriendRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {RefreshTokenArgs} [RefreshTokenArgs]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshToken(RefreshTokenArgs, options) {
            return localVarFp.refreshToken(RefreshTokenArgs, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CustomerToken} [CustomerToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        register(CustomerToken, options) {
            return localVarFp.register(CustomerToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Customers, Erp)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id, options) {
            return localVarFp.remove(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Initiates account deletion request. Sends confirmation email with token. (Auth roles: FrontEndUsers)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestAccountDeletion(options) {
            return localVarFp.requestAccountDeletion(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ChangePasswordToken} [ChangePasswordToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword(ChangePasswordToken, options) {
            return localVarFp.resetPassword(ChangePasswordToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [email]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPasswordRequest(email, options) {
            return localVarFp.resetPasswordRequest(email, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ChangePasswordTokenV2} [ChangePasswordTokenV2]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPasswordV2(ChangePasswordTokenV2, options) {
            return localVarFp.resetPasswordV2(ChangePasswordTokenV2, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {string} [businessCode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveBusinessCode(businessCode, options) {
            return localVarFp.saveBusinessCode(businessCode, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [pageIndex]
         * @param {number} [pageSize]
         * @param {string} [searchText]
         * @param {string} [startsWith]
         * @param {string} [sort]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUserAlias(pageIndex, pageSize, searchText, startsWith, sort, options) {
            return localVarFp.searchUserAlias(pageIndex, pageSize, searchText, startsWith, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {SettingValue} SettingValue
         * @param {string} key
         * @param {string} [group]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setCurrentCustomerMeta(SettingValue, key, group, options) {
            return localVarFp.setCurrentCustomerMeta(SettingValue, key, group, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers,Customers)
         * @param {SettingValue} SettingValue
         * @param {number} customerId
         * @param {string} key
         * @param {string} [group]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setMeta(SettingValue, customerId, key, group, options) {
            return localVarFp.setMeta(SettingValue, customerId, key, group, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Customers, Erp)
         * @param {CustomerToken} [CustomerToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(CustomerToken, options) {
            return localVarFp.update(CustomerToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {UpdateCustomerDimensionReq} [UpdateCustomerDimensionReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomerDimensionValues(UpdateCustomerDimensionReq, options) {
            return localVarFp.updateCustomerDimensionValues(UpdateCustomerDimensionReq, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {CustomerEmployeeToken} [CustomerEmployeeToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmployee(CustomerEmployeeToken, options) {
            return localVarFp.updateEmployee(CustomerEmployeeToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {ChangePasswordToken} [ChangePasswordToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePassword(ChangePasswordToken, options) {
            return localVarFp.updatePassword(ChangePasswordToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary The customer\'s own answer to the personalized-messages consent, from the storefront profile. A dedicated action rather than M:BizWeb.NC.API.Controllers.CustomersController.UpdateProfile(BizWeb.NC.API.Models.Customers.CustomerToken), so a consent toggle neither needs the personal details to validate nor re-runs the profile\'s loyalty events and customer-plugin update. (Auth roles: FrontEndUsers)
         * @param {PersonalizedMessagesConsentToken} [PersonalizedMessagesConsentToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePersonalizedMessagesConsent(PersonalizedMessagesConsentToken, options) {
            return localVarFp.updatePersonalizedMessagesConsent(PersonalizedMessagesConsentToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {CustomerToken} [CustomerToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProfile(CustomerToken, options) {
            return localVarFp.updateProfile(CustomerToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [guid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validatePasswordResetRequest(guid, options) {
            return localVarFp.validatePasswordResetRequest(guid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ChangePasswordTokenV2} [ChangePasswordTokenV2]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateResetPassPin(ChangePasswordTokenV2, options) {
            return localVarFp.validateResetPassPin(ChangePasswordTokenV2, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [guid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyRegistration(guid, options) {
            return localVarFp.verifyRegistration(guid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: FrontEndUsers)
         * @param {GenericToken} [GenericToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewVideo(GenericToken, options) {
            return localVarFp.viewVideo(GenericToken, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * CustomersApi - object-oriented interface
 * @export
 * @class CustomersApi
 * @extends {BaseAPI}
 */
class CustomersApi extends BaseAPI {
    /**
     *
     * @summary  (Auth roles: FrontEndUsers)
     * @param {CustomerEmployeeToken} [CustomerEmployeeToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    addEmployee(CustomerEmployeeToken, options) {
        return CustomersApiFp(this.configuration).addEmployee(CustomerEmployeeToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CustomerAppleToken} [CustomerAppleToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    appleLogin(CustomerAppleToken, options) {
        return CustomersApiFp(this.configuration).appleLogin(CustomerAppleToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Issues a one-time nonce challenge for the Sign in with Apple flow. The storefront requests this before initialising the Apple JS SDK, feeds `nonce` to Apple, and posts `nonceToken` back on M:BizWeb.NC.API.Controllers.CustomersController.AppleLogin(BizWeb.NC.Models.Customers.CustomerAppleToken) so the server can bind the identity token to this attempt without server state.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    appleNonce(options) {
        return CustomersApiFp(this.configuration).appleNonce(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Confirms and executes account deletion using token from email
     * @param {string} [token] The unique deletion confirmation token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    confirmAccountDeletion(token, options) {
        return CustomersApiFp(this.configuration).confirmAccountDeletion(token, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Customers,OrderApproval)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    countAll(options) {
        return CustomersApiFp(this.configuration).countAll(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Customers,FrontEndUsers)
     * @param {number} [customerId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    createCustomerImpersonation(customerId, options) {
        return CustomersApiFp(this.configuration).createCustomerImpersonation(customerId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: FrontEndUsers)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    deleteAccount(options) {
        return CustomersApiFp(this.configuration).deleteAccount(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: FrontEndUsers)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    deleteEmployee(id, options) {
        return CustomersApiFp(this.configuration).deleteEmployee(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CustomerFacebookToken} [CustomerFacebookToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    facebookLogin(CustomerFacebookToken, options) {
        return CustomersApiFp(this.configuration).facebookLogin(CustomerFacebookToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {GeneratePasswordRequestToken} [GeneratePasswordRequestToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    generatePasswordRequest(GeneratePasswordRequestToken, options) {
        return CustomersApiFp(this.configuration).generatePasswordRequest(GeneratePasswordRequestToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Customers, Erp)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    getAll(options) {
        return CustomersApiFp(this.configuration).getAll(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Customers)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    getAllByCustomerCategory(id, options) {
        return CustomersApiFp(this.configuration).getAllByCustomerCategory(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: FrontEndUsers)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    getAllCustomerDimensionValues(options) {
        return CustomersApiFp(this.configuration).getAllCustomerDimensionValues(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: System, Customers, Erp)
     * @param {CustomerGetAllRequest} [CustomerGetAllRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    getAllPost(CustomerGetAllRequest, options) {
        return CustomersApiFp(this.configuration).getAllPost(CustomerGetAllRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page]
     * @param {number} [psize]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    getAllReaders(page, psize, options) {
        return CustomersApiFp(this.configuration).getAllReaders(page, psize, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: FrontEndUsers)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    getBranches(options) {
        return CustomersApiFp(this.configuration).getBranches(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: FrontEndUsers)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    getBusinessCode(options) {
        return CustomersApiFp(this.configuration).getBusinessCode(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Orders, Customers, Erp)
     * @param {string} [erpSyncCode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    getByErpCode(erpSyncCode, options) {
        return CustomersApiFp(this.configuration).getByErpCode(erpSyncCode, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Customers, Erp)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    getById(id, options) {
        return CustomersApiFp(this.configuration).getById(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Customers)
     * @param {Array<number>} [request_body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    getByIds(request_body, options) {
        return CustomersApiFp(this.configuration).getByIds(request_body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [userAlias]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    getByUserAlias(userAlias, options) {
        return CustomersApiFp(this.configuration).getByUserAlias(userAlias, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: FrontEndUsers)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    getCouponOrderLines(options) {
        return CustomersApiFp(this.configuration).getCouponOrderLines(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: FrontEndUsers)
     * @param {string} key
     * @param {string} [group]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    getCurrentCustomerMeta(key, group, options) {
        return CustomersApiFp(this.configuration).getCurrentCustomerMeta(key, group, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    getCustomerAvailableLoyaltyPoints(options) {
        return CustomersApiFp(this.configuration).getCustomerAvailableLoyaltyPoints(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: FrontEndUsers)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    getCustomerDimensionValues(options) {
        return CustomersApiFp(this.configuration).getCustomerDimensionValues(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [guid]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    getCustomerOfPasswordResetRequest(guid, options) {
        return CustomersApiFp(this.configuration).getCustomerOfPasswordResetRequest(guid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: FrontEndUsers)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    getEmployees(options) {
        return CustomersApiFp(this.configuration).getEmployees(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary The product feeds published for the signed-in customer (an employee gets their company\'s), as absolute URLs. Empty when feeds are not published per customer or the customer has no GUID. (Auth roles: FrontEndUsers)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    getFeeds(options) {
        return CustomersApiFp(this.configuration).getFeeds(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    getGenders(options) {
        return CustomersApiFp(this.configuration).getGenders(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Groups the customer currently belongs to (read-only, for the admin customer form). (Auth roles: Customers)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    getGroups(id, options) {
        return CustomersApiFp(this.configuration).getGroups(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: FrontEndUsers)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    getLoyaltyEventInfo(options) {
        return CustomersApiFp(this.configuration).getLoyaltyEventInfo(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: FrontEndUsers)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    getLoyaltyPointsBalance(options) {
        return CustomersApiFp(this.configuration).getLoyaltyPointsBalance(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: FrontEndUsers,Customers)
     * @param {number} customerId
     * @param {string} key
     * @param {string} [group]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    getMeta(customerId, key, group, options) {
        return CustomersApiFp(this.configuration).getMeta(customerId, key, group, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: FrontEndUsers)
     * @param {number} [winPoints]
     * @param {number} [redeemPoints]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    getNextMilestone(winPoints, redeemPoints, options) {
        return CustomersApiFp(this.configuration).getNextMilestone(winPoints, redeemPoints, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: FrontEndUsers)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    getProfile(options) {
        return CustomersApiFp(this.configuration).getProfile(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    getReaderInfo(id, options) {
        return CustomersApiFp(this.configuration).getReaderInfo(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CustomerGoogleToken} [CustomerGoogleToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    googleLogin(CustomerGoogleToken, options) {
        return CustomersApiFp(this.configuration).googleLogin(CustomerGoogleToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [guid]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    impersonateCustomer(guid, options) {
        return CustomersApiFp(this.configuration).impersonateCustomer(guid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Customers, Erp)
     * @param {CustomerToken} [CustomerToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    insert(CustomerToken, options) {
        return CustomersApiFp(this.configuration).insert(CustomerToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Sample request:   POST /api/v1/Customers/IssueSlt  {   \"username\": \"user@my.org\",   \"password\": \"1234567890\"  }   Sample response:   {   \"token\": \"dsjhfcasod8n7fyoacw87y023874nyc023n8974ty02mcc347cn023470734yc208734ynt28\"  }
     * @summary Issue an slt token to be used for authentication in a second step
     * @param {BaseLoginArgs} BaseLoginArgs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    issueSlt(BaseLoginArgs, options) {
        return CustomersApiFp(this.configuration).issueSlt(BaseLoginArgs, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {LoginArgs} [LoginArgs]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    login(LoginArgs, options) {
        return CustomersApiFp(this.configuration).login(LoginArgs, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {LoginSltArgs} [LoginSltArgs]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    loginSlt(LoginSltArgs, options) {
        return CustomersApiFp(this.configuration).loginSlt(LoginSltArgs, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {RefreshTokenArgs} [RefreshTokenArgs]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    logout(RefreshTokenArgs, options) {
        return CustomersApiFp(this.configuration).logout(RefreshTokenArgs, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Customers)
     * @param {string} [term]
     * @param {number} [top]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    lookup(term, top, options) {
        return CustomersApiFp(this.configuration).lookup(term, top, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: FrontEndUsers)
     * @param {GenericToken} [GenericToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    readBlog(GenericToken, options) {
        return CustomersApiFp(this.configuration).readBlog(GenericToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Invites a friend by e-mail (BW-8460). The answer is the same whether or not the address is already a customer; the mail goes out only when it isn\'t (and wasn\'t invited by this customer in the last 30 days). At most 3 an hour. (Auth roles: FrontEndUsers)
     * @param {ReferAFriendRequest} [ReferAFriendRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    referAFriend(ReferAFriendRequest, options) {
        return CustomersApiFp(this.configuration).referAFriend(ReferAFriendRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {RefreshTokenArgs} [RefreshTokenArgs]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    refreshToken(RefreshTokenArgs, options) {
        return CustomersApiFp(this.configuration).refreshToken(RefreshTokenArgs, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CustomerToken} [CustomerToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    register(CustomerToken, options) {
        return CustomersApiFp(this.configuration).register(CustomerToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Customers, Erp)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    remove(id, options) {
        return CustomersApiFp(this.configuration).remove(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Initiates account deletion request. Sends confirmation email with token. (Auth roles: FrontEndUsers)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    requestAccountDeletion(options) {
        return CustomersApiFp(this.configuration).requestAccountDeletion(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ChangePasswordToken} [ChangePasswordToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    resetPassword(ChangePasswordToken, options) {
        return CustomersApiFp(this.configuration).resetPassword(ChangePasswordToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [email]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    resetPasswordRequest(email, options) {
        return CustomersApiFp(this.configuration).resetPasswordRequest(email, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ChangePasswordTokenV2} [ChangePasswordTokenV2]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    resetPasswordV2(ChangePasswordTokenV2, options) {
        return CustomersApiFp(this.configuration).resetPasswordV2(ChangePasswordTokenV2, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: FrontEndUsers)
     * @param {string} [businessCode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    saveBusinessCode(businessCode, options) {
        return CustomersApiFp(this.configuration).saveBusinessCode(businessCode, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [pageIndex]
     * @param {number} [pageSize]
     * @param {string} [searchText]
     * @param {string} [startsWith]
     * @param {string} [sort]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    searchUserAlias(pageIndex, pageSize, searchText, startsWith, sort, options) {
        return CustomersApiFp(this.configuration).searchUserAlias(pageIndex, pageSize, searchText, startsWith, sort, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: FrontEndUsers)
     * @param {SettingValue} SettingValue
     * @param {string} key
     * @param {string} [group]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    setCurrentCustomerMeta(SettingValue, key, group, options) {
        return CustomersApiFp(this.configuration).setCurrentCustomerMeta(SettingValue, key, group, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: FrontEndUsers,Customers)
     * @param {SettingValue} SettingValue
     * @param {number} customerId
     * @param {string} key
     * @param {string} [group]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    setMeta(SettingValue, customerId, key, group, options) {
        return CustomersApiFp(this.configuration).setMeta(SettingValue, customerId, key, group, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Customers, Erp)
     * @param {CustomerToken} [CustomerToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    update(CustomerToken, options) {
        return CustomersApiFp(this.configuration).update(CustomerToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: FrontEndUsers)
     * @param {UpdateCustomerDimensionReq} [UpdateCustomerDimensionReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    updateCustomerDimensionValues(UpdateCustomerDimensionReq, options) {
        return CustomersApiFp(this.configuration).updateCustomerDimensionValues(UpdateCustomerDimensionReq, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: FrontEndUsers)
     * @param {CustomerEmployeeToken} [CustomerEmployeeToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    updateEmployee(CustomerEmployeeToken, options) {
        return CustomersApiFp(this.configuration).updateEmployee(CustomerEmployeeToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: FrontEndUsers)
     * @param {ChangePasswordToken} [ChangePasswordToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    updatePassword(ChangePasswordToken, options) {
        return CustomersApiFp(this.configuration).updatePassword(ChangePasswordToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary The customer\'s own answer to the personalized-messages consent, from the storefront profile. A dedicated action rather than M:BizWeb.NC.API.Controllers.CustomersController.UpdateProfile(BizWeb.NC.API.Models.Customers.CustomerToken), so a consent toggle neither needs the personal details to validate nor re-runs the profile\'s loyalty events and customer-plugin update. (Auth roles: FrontEndUsers)
     * @param {PersonalizedMessagesConsentToken} [PersonalizedMessagesConsentToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    updatePersonalizedMessagesConsent(PersonalizedMessagesConsentToken, options) {
        return CustomersApiFp(this.configuration).updatePersonalizedMessagesConsent(PersonalizedMessagesConsentToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: FrontEndUsers)
     * @param {CustomerToken} [CustomerToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    updateProfile(CustomerToken, options) {
        return CustomersApiFp(this.configuration).updateProfile(CustomerToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [guid]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    validatePasswordResetRequest(guid, options) {
        return CustomersApiFp(this.configuration).validatePasswordResetRequest(guid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ChangePasswordTokenV2} [ChangePasswordTokenV2]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    validateResetPassPin(ChangePasswordTokenV2, options) {
        return CustomersApiFp(this.configuration).validateResetPassPin(ChangePasswordTokenV2, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [guid]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    verifyRegistration(guid, options) {
        return CustomersApiFp(this.configuration).verifyRegistration(guid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: FrontEndUsers)
     * @param {GenericToken} [GenericToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    viewVideo(GenericToken, options) {
        return CustomersApiFp(this.configuration).viewVideo(GenericToken, options).then((request) => request(this.axios, this.basePath));
    }
}

export { CustomersApi, CustomersApiAxiosParamCreator, CustomersApiFactory, CustomersApiFp };
//# sourceMappingURL=customers-api.js.map
